import dynamic from "next/dynamic";
import SkeletonListReview from "components/skeleton/list_review/listReview";

const TrandingReview = dynamic(
	() => import("Containers/tranding_review/trandingReview"), { loading: () => <SkeletonListReview />, ssr: true },
);

const Desktop = (props) => {

	const prop = props;

	return (
		<div className="container-newest" id="card-top">

			<TrandingReview
				{...prop}
			/>

			<style jsx>
				{`
					.container-newest {
						display: flex;
						flex-direction: column;
						align-items: flex-start ;

						max-width: 1280px;
						margin: 0 auto;
						width: 100%;
					}
					
				`}
			</style>
		</div>
	);

};

export default Desktop;
